module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('header', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "subject"
    }
  }, [(this.sharedState.pledgeCompleted) ? _c('span', {
    staticClass: "bg"
  }, [_vm._v("\n      Looking forward to seeing you run"), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.sharedState.newUser.name),
      expression: "this.sharedState.newUser.name"
    }]
  }, [_vm._v(", " + _vm._s(_vm._f("firstName")(this.sharedState.newUser.name)))]), _vm._v("!\n    ")]) : _c('span', {
    staticClass: "bg"
  }, [_vm._v("\n      Pledge to run at least 30 minutes a month\n    ")]), _vm._v(" ")]), _vm._v(" ")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "pure-g logo-wrap"
  }, [_c('div', {
    staticClass: "pure-u-6-24 logo-side"
  }, [_c('div', {
    staticClass: "logoline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-12-24",
    attrs: {
      "id": "logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-6-24 logo-side"
  }, [_c('div', {
    staticClass: "logoline"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3911bd0f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 106
// module chunks = 2